module.exports = __webpack_public_path__ + "static/media/dress-1.fddace52.jpg";